import { Keyframes, keyframes } from '@emotion/react';

const getThumbsUpAnim = (anim: number[], index = 0): Keyframes => keyframes`
    0% {
      opacity: 0;
    }
    5% {
      opacity: 1;
      transform:  translate(${anim[index]}px,0px) scale(0.55, 0.55) color: #bb0000;
    }
    50% {
      opacity: 1;
      transform:  translate(${anim[++index]}px,-100px) scale(0.55, 0.55);
    }
    75% {
      opacity: 1;
      transform:  translate(${anim[++index]}px,-150px) scale(0.55, 0.55);
    }
    100% {
      opacity: 0;
      transform:  translate(${anim[++index]}px,-200px) scale(0.55, 0.55);
    }
`;

const animationFrames = [
  [0, -15, -22, -30],
  [0, -5, -12, -20],
  [0, 8, 11, 15],
  [0, -8, -11, -15],
];

const animations = Array.from(Array(animationFrames.length)).map((_element, id: number) => {
  return getThumbsUpAnim(animationFrames[id]);
});

export default animations;
